<div *ngIf="error" class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 my-8 custom-content-container" role="alert">
    <strong class="font-bold">Whoops! </strong>
    <span class="block sm:inline">{{error}}</span>
</div>
<div *ngIf="info">
    <div class="hidden w-full bg-gradient-to-r from-[#0a5cb7] to-[#003e80] text-white font-bold py-4 px-6 flex justify-center items-center">
        Continue your Legal Resources plan via {{billingType()}}
    </div>
    
    <!-- Call-to-Action Section -->
    <div class="text-[#1b3157] py-12 px-6 text-center">
        <div class="max-w-3xl mx-auto">
            <!-- Title and Description -->
            <h2 class="text-2xl md:text-3xl font-bold mb-4">Ready to get started?</h2>
            <p class="text-lg mb-8">Choose the perfect Legal Resources plan for your needs and start your enrollment today.</p>
        </div>
    </div>

    <div *ngIf="info.customContent" class="w-full py-10 px-20 bg-[#fafafa] custom-content-container">
        <div class="custom-content" [innerHTML]="info.customContent | safeHtml"></div>
    </div>

    <div *ngIf="!info.customContent" class="w-full py-10 px-20 bg-[#fafafa] custom-content-container text-center">
        <h2 class="text-2xl md:text-3xl font-bold mb-4">{{info.clientName}}</h2>
    </div>

    <div *ngIf="showPathTabs" class="container mx-auto px-6 lg:px-20 max-w-4xl mb-8">
        <h2 class="text-xl font-bold text-center mb-4">How would you like to enroll?</h2>
        <div class="path-tabs" role="tablist" aria-label="Enrollment path">
            <button
                *ngFor="let path of pathTabs"
                type="button"
                role="tab"
                class="path-tab"
                [class.path-tab--active]="selectedEnrollmentType === path.type"
                [attr.aria-selected]="selectedEnrollmentType === path.type"
                [attr.aria-label]="path.ariaLabel"
                (click)="onSelectPath(path.type)">
                <span class="path-tab__label">{{ path.label }}</span>
                <span *ngIf="path.caption" class="path-tab__caption">{{ path.caption }}</span>
            </button>
        </div>
    </div>

    <div *ngIf="showPathTabs && !selectedEnrollmentType" class="text-center text-gray-600 mb-8 px-6">
        Choose Open Enrollment or New Hire to see products available on that effective date.
    </div>

    <div *ngIf="selectedEnrollmentType">
        <h2 class="text-xl font-bold items-center justify-center text-center mb-4">Please select one of the products below</h2>
        <div *ngIf="errorProduct" class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 my-8 custom-content-container w-[700px]" role="alert">
            <span class="block sm:inline">{{errorProduct}}</span>
        </div>
        <div *ngIf="productList.length === 0" class="text-center text-gray-600 mb-8 px-6">
            No products are available for this enrollment date.
        </div>
        <div *ngIf="productList.length > 0" class="container mx-auto px-6 lg:px-20 flex-grow max-w-4xl">
            <div class="bg-white rounded-lg shadow-md overflow-hidden">
                <div class="divide-y divide-gray-200">
                    <div *ngFor="let productGroup of productList" class="p-6 hover:bg-gray-50 transition-colors duration-200">
                        <h3 class="text-lg font-semibold text-gray-800 mb-4">{{ planType(productGroup.productType) | titlecase }}</h3>
                        <mat-button-toggle-group *ngIf="productGroup.productType.toLowerCase().includes('legal')" class="!border-0 !rounded-none flex flex-wrap gap-2" [value]="selectedProduct['legal']" aria-label="Product Type">
                            <mat-button-toggle *ngFor="let plan of productGroup.items" [value]="plan" (click)="toggleProduct('legal', plan)" class="!border-1 rounded-lg">
                                {{ plan.productName }}
                                <span class="text-sm text-gray-500 ml-1">{{ planDisplayRate(plan) | currency }}</span>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                        <mat-button-toggle-group *ngIf="productGroup.productType.toLowerCase().includes('idp')" class="!border-0 !rounded-none flex flex-wrap gap-2" [value]="selectedProduct['idp']" aria-label="Product Type">
                            <mat-button-toggle *ngFor="let plan of productGroup.items" [value]="plan" (click)="toggleProduct('idp', plan)" class="!border-1 rounded-lg">
                                {{ plan.productName }}
                                <span class="text-sm text-gray-500 ml-1">{{ planDisplayRate(plan) | currency }}</span>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <div *ngIf="isDirectBilled && info.paymentFrequencies.length > 1" class="p-6 hover:bg-gray-50 transition-colors duration-200">
                        <h3 class="text-lg font-semibold text-gray-800 mb-4">Choose payment frequency:</h3>
                        <mat-button-toggle-group class="!border-0 !rounded-none flex flex-wrap gap-2" [(value)]="info.defaultPaymentFrequency" aria-label="Payment Frequency">
                            <mat-button-toggle *ngFor="let frequency of info.paymentFrequencies" [value]="frequency.numberOfIntervals" class="!border-1 rounded-lg mr-2">
                                {{ intervalName(frequency.numberOfIntervals) }}
                                <span *ngIf="frequency.discount" class="text-sm text-green-600">
                                    ({{ frequency.discount / 100 | percent }} off)
                                </span>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>
            </div>
        </div>
    </div>

       <!-- Sticky Bottom Button -->
    <div class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        <div class="max-w-4xl mx-auto px-4 py-3">
            <div *ngIf="showStickyEnrollmentBar" class="flex flex-col sm:flex-row items-center gap-3 justify-between">

                <div *ngIf="getPriceWithDiscount() > 0"
                     class="flex flex-wrap items-baseline gap-1 sm:gap-2 text-center sm:text-left">
                    <span class="text-lg font-bold text-[#1e3a5f]">Total:</span>
                    <span class="line-through text-gray-500 text-base" *ngIf="getPrice() > getPriceWithDiscount()">
                        {{ getPrice() | currency }}
                    </span>
                    <span class="text-2xl font-extrabold text-[#1e3a5f] whitespace-nowrap">{{ getPriceWithDiscount() | currency }}</span>
                    <span class="text-sm font-semibold text-[#314868] whitespace-nowrap">/{{ paymentFrequency() }}</span>
                    <span class="text-sm text-green-600 font-semibold" *ngIf="discountApplied > 0">({{ discountApplied/100 | percent }} discount)</span>
                </div>

                <div class="enroll-cta-group" *ngIf="showFutureOpenEnrollmentNotice || (selectedPath && getPriceWithDiscount() > 0)">
                    @if (showFutureOpenEnrollmentNotice) {
                        <button
                            type="button"
                            class="enroll-btn"
                            disabled
                            [attr.aria-label]="unavailableEnrollmentLabel">
                            @if (futureOpenEnrollmentStart) {
                                <span class="enroll-btn__stack">
                                    <span class="enroll-btn__line">Open Enrollment Starts:</span>
                                    <span class="enroll-btn__subline">{{ futureOpenEnrollmentStart }}</span>
                                </span>
                            } @else {
                                {{ unavailableEnrollmentLabel }}
                            }
                        </button>
                    }
                    @if (selectedPath && getPriceWithDiscount() > 0) {
                        <button
                            type="button"
                            class="enroll-btn"
                            [attr.aria-label]="selectedPath.ariaLabel"
                            (click)="goToEnrollment()">
                            <span class="enroll-btn__inner">
                                <span class="enroll-btn__stack">
                                    <span class="enroll-btn__line">{{ selectedPath.label }}</span>
                                    @if (selectedPath.caption) {
                                        <span class="enroll-btn__subline">{{ selectedPath.caption }}</span>
                                    }
                                </span>
                                <svg class="arrow" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                                </svg>
                            </span>
                        </button>
                    }
                </div>
            </div>
            <p *ngIf="showUnavailableEnrollmentMessage" class="enroll-cta-unavailable text-sm font-semibold text-gray-600 text-center sm:text-right max-w-md sm:max-w-xs sm:ml-auto">
                {{ unavailableEnrollmentLabel }}
            </p>
        </div>
        <app-footer>
            <button
                *ngIf="showCancellationRequestLink"
                type="button"
                class="landing-cancel-link"
                (click)="openCancellationRequest()">
                Cancel my current plan(s)
            </button>
        </app-footer>
    </div>
    
    <!-- Bottom spacer to prevent content being hidden behind sticky button -->
    <div class="h-30"></div>

</div>
<div *ngIf="!info && !error" class="flex justify-center items-center grow">
    <mat-spinner></mat-spinner>
</div>
